import { Flex } from '@chakra-ui/react';
import {
  ListingComparableSetFragment,
  ListingComparableSetSource,
  MlsListingFragment,
} from '@client/graphql/__generated__/types';
import { ComparableState } from '~/apps/consumer/pages/ListingSetup/Comparables/ComparablesPage';
import { ComparableColumn } from '../../../Listings/Comparables/ComparableColumns/ComparableColumn';
import { ComparablesContainer } from '../../styledComponents';

export const ViewCompsColumns = ({
  isPrint,
  isForPdf,
  mainMlsListing,
  comps,
  comparableSet,
}: {
  isPrint?: boolean;
  isForPdf?: boolean;
  mainMlsListing: MlsListingFragment;
  comps: ComparableState[];
  comparableSet?: ListingComparableSetFragment;
}) => {
  return (
    <Flex
      pl={isPrint ? 0 : { base: 2, md: 0 }}
      py={isPrint ? 0 : { base: 2, md: 0 }}
      width="100%"
    >
      <ComparablesContainer
        style={
          isPrint
            ? {
                breakBefore: 'page',
                marginTop: '30px',
              }
            : {}
        }
        width="100%"
      >
        <ComparableColumn
          isMainListing
          isEditMode={false}
          isForPdf={isForPdf}
          mainMlsListing={mainMlsListing}
          mlsListing={mainMlsListing}
          showAdjustments={true}
          showNotes={true}
          source={ListingComparableSetSource.SYSTEM}
        />
        {comps.map((comp) => (
          <ComparableColumn
            key={comp.mlsListing.id}
            comparableSet={comparableSet}
            isEditMode={false}
            isForPdf={isForPdf}
            isMainListing={false}
            mainMlsListing={mainMlsListing}
            mlsListing={comp.mlsListing}
            showAdjustments={true}
            showNotes={true}
            source={comp.source}
          />
        ))}
      </ComparablesContainer>
    </Flex>
  );
};
